import '@/assets/main.scss'
import '@/assets/credit-search.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import CreditSearchApp from '@/CreditSearchApp.vue'
import { updateDevMode, updateUser } from '@/common/utility'

const pinia = createPinia()

updateDevMode()
createApp(CreditSearchApp).use(pinia).mount('#credit-search-app')

updateUser()
